export default function getShortenedPodName(podName) {
    /**
     * This method transforms the long pod name to shortened pod name using vmc conventions (see PodUtil#buildDisplayName in Vault repo).
     * Because we do not have an environment xml file, like in VMC, we need the region map which corresponds to the region override variables
     * in the Environment-production.xml file in Vault Repo.
     * We are not concerned whether the pod is in dev or production because we are using the same format as Veeva Trust, so we only want the
     * region using the region mapping and the unique pod number.
     * For appstats, we use production and dev vmc data, so these variables can be hardcoded. If we use another environment,
     * like performance or infra, these region mappings could be different, but that is not something appstats will have to be
     * concerned with.
     * @param podName pod name in the VMC database i.e. "VLT-US-EAST-1-DEV-1012"
     * @return podName shortened pod name that is usually displayed in Veeva Trust/VMC i.e. "vv1-1012"
     */
    const regionMap = {
        us: '1',
        eu: '2',
        ap: '3',
        ca: '4',
        sa: '5',
    };
    if (podName) {
        const podNameParts = podName.split('-');
        if (podNameParts.length === 6) {
            const region = regionMap[podNameParts[1].toLowerCase()];
            const podNum = podNameParts[5];
            return `vv${region}-${podNum}`;
        }
    }
    return podName;
}
